import React from 'react';
import ReactDOM from 'react-dom';
import { SignalR, ConnectionState} from "./RemoteCommands/SignalR";
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
(document as any).addEventListener("DOMContentLoaded", () => {

    SignalR.Initialize();
    SignalR.ConnectionStateChanged.subscribe(async () => {
        console.log(ConnectionState[SignalR.ConnectionState]);
    });
});